import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const useProviderResource = (enabled) => {
  const trans = useSelector(translator);
  const resourcesApi = useSelector((state) => state.apis.resourcesApi);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);

  useEffect(() => {
    if (!enabled) return;

    const successCallback = (info) => {
      const resources = info?.resources;
      const latestResource = Array.isArray(resources)
        ? resources.reduce((latest, resource) => {
            const resourceTime = Date.parse(resource?.create_time ?? '');
            const latestTime = Date.parse(latest?.create_time ?? '');
            return !latest ||
              (Number.isFinite(resourceTime) &&
                (!Number.isFinite(latestTime) || resourceTime > latestTime))
              ? resource
              : latest;
          }, null)
        : null;
      const imageUrl = latestResource?.downloadurl;
      if (imageUrl) {
        setBackgroundImageUrl(imageUrl);
      } else {
        console.warn('No background image found in provider resources');
      }
    };
    const errorCallback = (error) => {
      console.error('Error fetching provider background image:', error.message);
    };

    try {
      resourcesApi.getProviderResources(
        apiCallback({
          translator: trans,
          errorCallback,
          failCallback: errorCallback,
          successCallback,
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  }, [enabled, resourcesApi, trans]);

  return backgroundImageUrl;
};

export default useProviderResource;
